import merge from 'lodash-es/merge';
import { TColorDefinition, TGetColorStateDefinition, TStates } from '../types';
import applyStatesGetColor from './applyStatesGetColor';
import { Theme } from 'theme-ui';

/**
 * Esta función está pensada para ser utilizada dentro del objeto colors del
 * tema. Aplica recursivamente los distintos estados a todos los elementos
 * contenidos dentro de los objetos pasados como parámetro en properties.
 *
 * Es posible elegir cuáles estados se aplican y cuáles no mediante el segundo
 * parámetro, que es un objeto cuyas propiedades serán tomadas en cuenta
 * únicamente cuando tienen valor false, en cuyo caso no se aplicará el estado
 * correspondiente.
 *
 * @param properties
 * @param states
 */
export default function applyStates(
  properties: Record<string, string | TGetColorStateDefinition>[],
  theme: Theme,
  states?: TStates,
) {
  properties.forEach?.((def) => {
    Object.entries(def).forEach(([key, value]) => {
      if (typeof value === 'string') return;
      const definition = value as Required<TColorDefinition>;

      if (typeof definition !== 'string' && !definition.preventParse) {
        if (!definition.active) definition.active = {};
        if (!definition.checked) definition.checked = {};
        if (!definition.focus) definition.focus = {};
        if (!definition.disabled) definition.disabled = {};
        if (!definition.hover) definition.hover = {};
        if (!definition.selected) definition.selected = {};

        const newDefinition = applyStatesGetColor(
          definition,
          theme.palette,
          states,
        );
        // eslint-disable-next-line no-param-reassign
        def[key] = merge(newDefinition, definition);
      }
    });
  });
}
